var MOBILE_CARD_MOVE_POSITION;
const DESKTOP_CARD_MOVE_POSITION = 411;
const MOBILE_SCREEN_SIZE = 880;

function lastTextCard(selector) {
    var move_position = getMovePosition();
    var carousel_selected = selector.nextElementSibling.firstElementChild;
    let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
    if (actual_position > 0) {
        actual_position -= move_position;
        carousel_selected.scrollLeft -= move_position;
        carousel_selected.setAttribute("actualPosition", actual_position); 
        selector.nextElementSibling.nextElementSibling.style.visibility = "visible";
        if(actual_position <= 0) {
            selector.style.visibility = "hidden";
        }
    }
}

function nextTextCard(selector) {
    var move_position = getMovePosition();
    var carousel_selected = selector.previousElementSibling.firstElementChild;
    const trackWidth = (carousel_selected.scrollWidth - DESKTOP_CARD_MOVE_POSITION - carousel_selected.offsetWidth);
    let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
    if (actual_position < trackWidth) {
        actual_position += move_position;
        carousel_selected.scrollLeft += move_position;
        carousel_selected.setAttribute("actualPosition", actual_position); 
        selector.previousElementSibling.previousElementSibling.style.visibility = "visible";
        if(actual_position >= trackWidth) {
            selector.style.visibility = "hidden";
            selector.childNodes[0].style.visibility = "hidden";
        }
    }
}

function getMovePosition() {
    if(window.innerWidth > MOBILE_SCREEN_SIZE){
        return DESKTOP_CARD_MOVE_POSITION;
    }
    else {
        const cards = document.getElementsByClassName("text_carrousel_card");
        let style = getComputedStyle(cards[0]);
        let marginLeft = parseInt(style.marginLeft);
        let marginRight = parseInt(style.marginRight);
        MOBILE_CARD_MOVE_POSITION = cards[0].offsetWidth + marginLeft + marginRight;
        return MOBILE_CARD_MOVE_POSITION;
    }
}